(() => {
  if (window.calmauraGuideClicksBound) return;
  window.calmauraGuideClicksBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('.ca-guide a');
    if (!link || !new URL(link.href).pathname.startsWith('/products/')) return;
    const guide = link.closest('[data-ca-guide]');
    const detail = {guide: guide.dataset.caGuide, destination: new URL(link.href).pathname, location: link.closest('.ca-hero') ? 'hero' : 'body'};
    document.dispatchEvent(new CustomEvent('calmaura:guide_pdp_click', {detail}));
  });
})();
